<template>
	<main>
		<!-- Donasi -->
		<section class="mb-12">
			<div class="vx-row justify-between w-full mb-8">
				<div class="vx-col w-full lg:w-2/3">
					<img v-lazy="`/assets/images/zxcare/donasi.svg`" alt="" class="w-24 lg:w-48" />
				</div>
			</div>
			<!-- List data campaign -->
			<main>
				<!-- Kategori Campaign -->
				<header class="mb-12">
					<campaign-category @filter="filterCampaign" :categories="categories" />
				</header>
				<!-- / -->
				<campaign-data :data="campaigns" :total="totalZxCareCampaign" />
				<section class="flex justify-center">
					<vs-button 
						size="small"
					    v-for="(item, i) in numPage"
					    :key="i"
					    class="rounded-none"
					    :type="item.active ? 'filled' : 'border'"
					    @click.prevent="change(item.start, item.num)">{{item.num}}</vs-button>
				</section>
			</main>
			<!-- / -->
		</section>
		<!-- / -->

		<zis-portal :category="category" />

		<!-- Divider -->
		<zakat-calculator />
		<!-- / -->
	</main>
</template>
<script>
import CampaignData from '@/views/home/campaign/components/CampaignData.vue'
import { mapState } from 'vuex'
export default {
  data () {
    return {
		categories: [],
      campaigns: [],
      numPage: [],
	  category: [],
      activePage: 1,
      params: {
        ord: 'desc',
        start: 0,
        status: 1,
        length: 12
      }
    }
  },
  computed: {
	  ...mapState('campaign', ['totalZxCareCampaign'])
  },
  components: {
	  ZisPortal: () => import('./components/ZisPortal.vue'),
	  ZakatCalculator: () => import('./components/ZakatCalculator.vue'),
    CampaignData,
	CampaignCategory: () => import('./components/DataCategory.vue')
  },
  methods: {
	filterCampaign(type) {
		this.params = {
			ord: 'desc',
			start: 0,
			status: 1,
			length: 12
		};

		if(type !== 'all') {
			this.params.kat_id = type;
		}

		if(this.$route.query.u) {
			const userId = Buffer.from(this.$route.query.u, 'base64').toString();
			this.params.user_id = userId;
		}

		this.getCampaign();
	},
    change (start, activePage) {
		const length = this.params.length
		this.params = {
			ord: 'desc',
			start,
			status: 1,
			length
		};

		if(this.$route.query.u) {
			const userId = Buffer.from(this.$route.query.u, 'base64').toString();
			this.params.user_id = userId;
		}

		this.activePage = activePage;
		this.getCampaign();
    },
	getCategoryCampaign() {
		this.$store.dispatch('campaign/getCategory')
		.then(categories => {
			
			// Object.assign(this.categories, categories)
			this.categories = categories
			this.categories.map((item, i) => {
				item.class = ''
				if(i == 0) {
					item.class = 'button-filter-active'
				}
			})
		})
	},
    getCampaign () {
      this.$vs.loading()
	  this.campaigns = []
      this.$store.dispatch('campaign/getZxCareData', {params: this.params, mutation: 'SET_DATA_ZXCARE'})
        .then(campaign => {
		
			this.numPage = []
			this.campaigns = []
			this.$vs.loading.close()
			this.campaigns = campaign
			if (this.totalZxCareCampaign > 0) {
				const totalNum = Math.ceil(this.totalZxCareCampaign / this.params.length)
				
				for (let i = 0; i < totalNum; i++) {
					const num = i + 1
					const start = (num - 1) * this.params.length
					this.numPage.push({
						active: false,
						num,
						start
					});
				}
							
				this.numPage.forEach(item => {
					if (item.num === this.activePage) {
					item.active = true;
					} else {
					item.active = false;
					}
				});
			}
        })
        .catch(e => {
			console.error(e);
			this.$vs.loading.close();
			if (e.response) console.error(e.response);
			this.$vs.notify({
				title: 'Oops',
				text: e.response.data.message,
				color: 'warning',
				position: 'top-right'
			});
			return false;
        });
    },
		getZisCategory() {
			this.$vs.loading()

			this.$store.dispatch('getZisCategory')
			.then(kategori => {
				this.$vs.loading.close()
				kategori.map(item => {
					item.file_url = null
					if(item.file !== null) {
						item.file_url = process.env.VUE_APP_STORAGE + '/' + item.file
					}
				})
				this.category = kategori
			})
			.catch(e => this.$vs.loading.close())
		}
	},
	beforeMount() {
		this.getZisCategory()
	},
	created () {
		// If category id exist in url
		if(this.$route.query.k) {
			this.params.kat_id = this.$route.query.k;
		}

		if(this.$route.query.u) {
			const userId = Buffer.from(this.$route.query.u, 'base64').toString();
			this.params.user_id = userId;
		}

		this.getCategoryCampaign();
		this.getCampaign();
	}
}
</script>
<style>
	.wow {
		width: 100% !important;
	}
	@media (min-width: 768px) {
		.wow {
			width: 9rem !important;
		}
	}
</style>